
// COMPONENTES
import ModalRecuperarContra from "../paginas/sesion/modalRecuperarContra"


function FooterInicioRegistro(props){


    const { desdeDonde } = props;



    return(
        <div>
            <div className='d-flex flex-column text-center mt-5'>
                {desdeDonde && desdeDonde==="borrar" ? null : <ModalRecuperarContra />}
                {/* <div style={{margin: '10px 0px 0px 0px'}} ><a style={{color: 'white', textDecoration: 'none'}} href="/registrar" >Registrarme</a></div>
                <div style={{margin: '10px 0px 0px 0px'}} ><a style={{color: 'white', textDecoration: 'none'}} href="/" >volver a Home</a></div> */}
                <div className="mt-3" ><p style={{color: 'var(--gris-claro-medio)'}} >Copyright &copy;  {new Date().getFullYear()}, Zervicy.</p></div>
                <div style={{margin: '-20px 0px 0px 0px'}}>
                    <p style={{color: 'var(--gris-claro-medio)'}}>
                        <i className='enlaces'>Powered by </i>
                        <a style={{textDecoration: 'none', color: 'white'}} rel="noreferrer" target='_blank' href="https://pretwor.com/" >
                            <i className='enlaces'>Pretwor</i>
                        </a>
                        <i className='enlaces'> · </i>
                        <a style={{textDecoration: 'none', color: 'white'}} rel="noreferrer" target='_blank' href="https://eduardoarias.co/" >
                            <i className='enlaces'>Eduardo Arias</i>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    )

}

export default FooterInicioRegistro